<nav class="sidebar" 
     [ngClass]="{'collapsed': isCollapsed && !isResponsiveMenu}"
     [@menuToggle]="isCollapsed ? (isResponsiveMenu? 'collapsedResponsive': 'collapsed') : (isResponsiveMenu? 'expandedResponsive': 'expanded')">
    <!-- Logo Section -->
    <div class="logo-section">
        <div class="logo">
            <div class="logo-content" *ngIf="!isCollapsed">
                <img src="assets/img/phoenix-1.png" alt="Phoenix Logo" class="logo-image-inline">
                <span class="logo-text">Phoenix</span>
            </div>
            <img src="assets/img/phoenix-1.png" alt="Phoenix Logo" class="logo-image" *ngIf="isCollapsed">
            <div class="logo-subtitle" *ngIf="!isCollapsed">
                <span>Enhancing</span>
                <span>Silver Value</span>
            </div>
        </div>
    </div>
    <button class="collapse-button" *ngIf="isResponsiveMenu && !isCollapsed" (click)="toggleMenu()">
        <i class="fas fa-times"></i>
    </button>

    <ul class="menu-list">
        <ng-container *ngFor="let option of menuOptions">
            <li [ngClass]="{ 
                'active': activeOption === option, 
                'collapsed-li': isCollapsed,
                'disabled-menu': isRouteDisabled(option.route),
                'red-button': shouldHaveRedButton(option),
                'section-header': option.isSectionHeader
            }">
                <a (click)="option.subOptions?.length ? toggleSubOptions(option) : toNavigate(option.route, option)"
                    [ngClass]="{ 
                    'active-link': activeOption === option && !activeSubOption, 
                    'collapsed-a': isCollapsed,
                    'disabled-link': isRouteDisabled(option.route)
                }">
                    <span class="fa-solid {{option.icon}}"
                        [ngClass]="{'disabled-icon': isRouteDisabled(option.route)}"></span>
                    <span *ngIf="!isCollapsed" class="text-option"
                        [ngClass]="{'disabled-text': isRouteDisabled(option.route)}">
                        {{ option.title }}
                    </span>
                    <span *ngIf="option.subOptions?.length && !isCollapsed" class="expand-icon">
                        <i *ngIf="option.expanded" class="fa-solid fa-angle-up"
                            [ngClass]="{'disabled-icon': isRouteDisabled(option.route)}"></i>
                        <i *ngIf="!(option.expanded)" class="fa-solid fa-angle-down"
                            [ngClass]="{'disabled-icon': isRouteDisabled(option.route)}"></i>
                    </span>
                </a>

                <ul *ngIf="option.expanded && option.subOptions?.length" class="submenu">
                    <ng-container *ngFor="let subOption of option.subOptions">
                        <!-- Encabezado de sección -->
                        <li *ngIf="subOption.isHeader" class="submenu-header">
                            <span *ngIf="!isCollapsed" class="text-option">
                                {{ subOption.title }}
                            </span>
                        </li>
                        <!-- Subopción normal -->
                        <li *ngIf="!subOption.isHeader" (click)="toNavigate(subOption.route, option, subOption)" [ngClass]="{ 
                            'active-suboption': activeSubOption === subOption,
                            'disabled-menu': isRouteDisabled(subOption.route) 
                        }">
                            <a>
                                <span class="fa-solid fa-circle-dot submenu-icon"
                                    [ngClass]="{'disabled-icon': isRouteDisabled(subOption.route)}"></span>
                                <span *ngIf="!isCollapsed" class="text-option"
                                    [ngClass]="{'disabled-text': isRouteDisabled(subOption.route)}">
                                    {{ subOption.title }}
                                </span>
                            </a>
                        </li>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
    </ul>

    <div class="bottom-menu">
        <a class="logout-button" (click)="logOut()">
            <span class="fa-solid fa-right-from-bracket logout-icon"></span>
            <span *ngIf="!isCollapsed" class="text-option">Cerrar sesión</span>
        </a>
    </div>

    <button class="collapse-toggle" *ngIf="!isResponsiveMenu" (click)="toggleMenu()">
        <i class="fa-solid" [ngClass]="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
    </button>
</nav>